import React, { useEffect, useRef } from "react";
import pico, {
  rgba_to_grayscale,
  update_memory,
  do_puploc,
  facefinder_classify_region,
  defaultParams,
  defaultSizeImage,
  Camvas
} from "@msvargas97/pico.js";
import Cookies from 'js-cookie';
import axios from '../../utils/axiosConfig';

import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import Snackbar from '@material-ui/core/Snackbar';
import MuiAlert from '@material-ui/lab/Alert';

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}


function ImagEProctoringCapture(props) {
  const shapeRef = useRef();
  const withPupilsRef = useRef();
  const camvas = useRef('Start');
  let token = Cookies.get('token');
  const { examDetail, hidden, setHidden ,resumeTest} = props;
  const closeInstruction = () => {
    
    window.location.reload(false);
  }

  const [snapShow, setSnapShow] = React.useState(true);
  const [open, setOpen] = React.useState(false);
  const [modal, setModal] = React.useState(false);
  const [message, setMessage] = React.useState('');
  const [countFace, setCountFace] = React.useState(0);
  const handleClick = () => {
    setOpen(true);
  };

  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return false;
    }
    setModal(false);
  };

  

  const saveImage = () => {
    if (countFace == 1) {
      var dataURL = document.getElementsByTagName("canvas")[0].toDataURL('image/jpeg', 0.5);
      
      axios.post('/test/saveImage', {
        headers: {
          'Access-Control-Allow-Origin': '*',
        }, userexamid: examDetail[0].id,
        instanceid: examDetail[0].instanceid,
        imagePath: dataURL
      }).then(resp => {
        
        resp.data.msg === 'SUCCESS' ? setHidden(true) : setHidden(false)
        onStop();

      }).catch(err => {
        setHidden(false);
        
      })
      setMessage('Webcam has been configured successfully.  Click on Start / Resume to continue...');
      setModal(true);
      setCountFace(0);
      resumeTest();
    } else if (countFace == 0) {
      
      saveErrorImage();
      setMessage('Webcam Configuration Failed. No Face Detected.');
      setModal(true);
    } else {
      
      saveErrorImage();
      setMessage('Webcam Configuration Failed. Multiple Face Detected.');
      setModal(true);

    }
  }
  const saveErrorImage = () => {
    if (countFace != 1) {
      var dataURL = document.getElementsByTagName("canvas")[0].toDataURL();
      
      axios.post('/test/saveErrorImage', {
        headers: {
          'Access-Control-Allow-Origin': '*',
        }, userexamid: examDetail[0].id,
        facecount: countFace,
        imagePath: dataURL
      }).then(resp => {
        
        resp.data.msg === 'SUCCESS' ? setHidden(false) : setHidden(true)
        onStop();

      }).catch(err => {
        setHidden(true);
        
      })
      // setMessage('Webcam has been configured successfully.  Click on Start / Resume to continue...');
      // setModal(true);
      setCountFace(0);
    }
  }
  useEffect(() => {
    async function init() {
      if (!pico.initialized) {
        await pico.load();
        
      }
    }
    init();
    let i;
    const ctx = document.getElementsByTagName("canvas")[0].getContext("2d");
    const image = defaultSizeImage;
    const processfn = function (video, dt) {
      // render the video frame to the canvas element and extract RGBA pixel data
      ctx.drawImage(video, 0, 0, 220, 140);

      const rgba = ctx.getImageData(0, 0, 480, 360).data;
      // prepare input to `run_cascade`
      image.pixels = rgba_to_grayscale(rgba, 480, 640);
      image.nrows = 360;
      image.ncols = 480;
      image.ldim = 480;


      // run the cascade over the frame and cluster the obtained detections
      // dets is an array that contains (r, c, s, q) quadruplets
      // (representing row, column, scale and detection score)
      let dets = pico.run_cascade(
        image,
        facefinder_classify_region,
        defaultParams
      );
      dets = update_memory(dets);
      dets = pico.cluster_detections(dets, 0.2); // set IoU threshold to 0.2


      // draw detections
      if(dets.length > 0){
      for (i = 0; i < dets.length; ++i)
        // check the detection score
        // if it's above the threshold, draw it
        // (the constant 50.0 is empirical: other cascades might require a different one)
        if (dets[i][3] > 0) {
          var r, c, s;
          const middleSize = dets[i][2] * 0.5;
          ctx.beginPath();
          if (shapeRef && shapeRef.current && shapeRef.current.value === "circle") {
            ctx.arc(dets[i][1], dets[i][0], middleSize, 0, 2 * Math.PI, false);
          } else {
            ctx.rect(
              dets[i][1] - middleSize,
              dets[i][0] - middleSize,
              dets[i][2],
              dets[i][2]
            );
          }
          ctx.lineWidth = 1;
          ctx.strokeStyle = "limegreen";
          ctx.stroke();
          setCountFace(countFace + 1);
          // if (!withPupilsRef.current.checked) continue;
          //
          // find the eye pupils for each detected face
          // starting regions for localization are initialized based on the face bounding box
          // (parameters are set empirically)
          // first eye
          // r = dets[i][0] - 0.075 * dets[i][2];
          // c = dets[i][1] - 0.175 * dets[i][2];
          // s = 0.35 * dets[i][2];
          // [r, c] = do_puploc(r, c, s, 127, image);
          // if (r >= 0 && c >= 0) {
          //   ctx.beginPath();
          //   ctx.arc(c, r, 2, 0, 2 * Math.PI, false);
          //   ctx.lineWidth = 3;
          //   ctx.strokeStyle = "limegreen";
          //   ctx.stroke();
          // }
          // // second eye
          // r = dets[i][0] - 0.075 * dets[i][2];
          // c = dets[i][1] + 0.175 * dets[i][2];
          // s = 0.35 * dets[i][2];
          // [r, c] = do_puploc(r, c, s, 127, image);
          // if (r >= 0 && c >= 0) {
          //   ctx.beginPath();
          //   ctx.arc(c, r, 2, 0, 2 * Math.PI, false);
          //   ctx.lineWidth = 3;
          //   ctx.strokeStyle = "limegreen";
          //   ctx.stroke();
          // }
        }
      }else{
        setCountFace(0);
      }
  }
    camvas.current = new Camvas(processfn); //camera canvas
    camvas.current.play();

    const listener = e => {
      // console.log(
      //   `${new Date().toLocaleString()} Camera canvas ${e.type} event...`
      // );
    };
    camvas.current.video.addEventListener("play", listener);
    camvas.current.video.addEventListener("pause", listener);

    return () => {
      camvas.current.video.removeEventListener("play", listener);
      camvas.current.video.removeEventListener("pause", listener);
      camvas.current = null;
    };
  }, []);

  const onPlay = () => {
    camvas.current.play();
    setSnapShow(true);
  }
  const onPause = () => {
    camvas.current.pause();

  }
  const onStop = () => {
    camvas.current.stop();
    setSnapShow(false);
  }
  return (
    <>
      <div style={{ display: 'none' }}>
        <center>
          <label>
            <input type="checkbox" ref={withPupilsRef} defaultChecked />
            with pupils
          </label>
          <select name="shape" ref={shapeRef}>
            <option value="circle">Circle</option>
            <option value="shape">Square</option>
          </select>
        </center>
      </div>
      <div>
        {/* <center>
          <input type="button" id="Start" value={`Start`} onClick={onPlay} />
          <span>{"  "}</span>
          <input type="button" value={`Pause`} onClick={onPause} />
          <span>{"  "}</span>
          <input type="button" value={`Stop`} onClick={onStop} />
        </center> */}
      </div>
      <div>
        <center>
          <canvas width="220" height="140"></canvas>
        </center>
      </div>
      <Grid item xs={12} style={{ textAlign: 'center'}}>


        {
          snapShow == true ?
            <>
              <Button variant="contained" color="primary" onClick={() => saveImage()}>
                <strong>Snap</strong>
              </Button>

              <Button variant="contained" style={{ marginLeft: '2rem' }} color="primary"  onClick={() => closeInstruction()}>
                <strong>Close</strong>
              </Button>
            </>
            :
            <>
              {/* <section>
                <h4 style={{textAlign:"center"}}>
                  To Re-snap photo click on Re-snap. Make sure that the photo is clearly visible inside circle. If not, test will be considered as 'Invalid'
        </h4>

              </section>
              <Button variant="contained" color="primary" onClick={() => onPlay()}>
                <strong>Re-Snap</strong>
              </Button> */}
              { hidden && examDetail[0].monitoringflag ? 
          
                <Button variant="contained"  style={{ marginLeft: '2rem' }}  color="primary" onClick={() => resumeTest()}>
                    <strong>{examDetail[0].status === '000' ? 'Start' : 'Resume'}</strong>
                </Button>    

            
                :
                <> <h4 style={{textAlign:"center"}}>
                To Re-snap photo click on Re-snap. Make sure that the photo is clearly visible inside circle. If not, test will be considered as 'Invalid'
      </h4>

            <Button variant="contained" color="primary" onClick={() => onPlay()}>
              <strong>Re-Snap</strong>
            </Button> 
            </>
            }
            </>
        }
      </Grid>
      <Snackbar open={modal} autoHideDuration={2000} onClose={handleClose}>
        <Alert onClose={handleClose} severity={message !== 'Webcam has been configured successfully.  Click on Start / Resume to continue...' ? 'error' : "success"}>
          {message}
        </Alert>
      </Snackbar>
    </>
  );
}

export default ImagEProctoringCapture;
